module.exports = __webpack_public_path__ + "img/20_39.1dcc9625.png";